import {useState} from 'react';

import OptionsCard from "../OptionsCard/OptionsCard"

import styles from "./BackgroundOptions.module.css"

export default function BackgroundOptions(props) {
  return (
    <OptionsCard>
      <label htmlFor="background-styles">Background Style</label>

      <select id="background-styles" onInput={(e) => {props.setBgType(e.target.value)}}>
        <option value="gradient" selected={props.bgType === "gradient"}>Gradient</option>
        <option value="solid" selected={props.bgType === "solid"}>Solid</option>
      </select>

      <div className={`${styles.gradientOptions} ${props.bgType === "gradient" ? styles.visible : ""}`}>
        <label htmlFor="color1">Color 1</label>
        <input type="color" id="color1" defaultValue={(props.bgValueGradient && props.bgValueGradient[0]) || "#000"} onInput={(e) => {props.setBgValueGradient([e.target.value, props.bgValueGradient[1]])}} />

        <label htmlFor="color2">Color 2</label>
        <input type="color" id="color2" defaultValue={(props.bgValueGradient && props.bgValueGradient[1] || "#000")} onInput={(e) => {props.setBgValueGradient([props.bgValueGradient[0], e.target.value])}} />

        <label htmlFor="gradient-rotation">Rotation</label>
        <span><input type="number" defaultValue={props.bgGradientRotation} onInput={(e) => {props.setBgGradientRotation(e.target.value)}} />deg</span>
      </div>

      <div className={`${styles.solidBgOption} ${props.bgType === "solid" ? styles.visible : ""}`}>
        <label htmlFor="solidColor">Color</label>
        <input type="color" id="solidColor" defaultValue={props.bgValueSolid} onInput={(e) => {props.setBgValueSolid(e.target.value)}} />
      </div>
    </OptionsCard>
  );
}
